const organization = {
    require_membership: 'O utilizador deve ser membro da organização para avançar.',
};
export default Object.freeze(organization);
